import { AppRoute } from '@agentselly/immodossier-shared';
import { Waitlist } from '@clerk/clerk-react';
import { useLinkProps } from '@tanstack/react-router';
import { useTheme } from '~/context/ThemeContext';
import { dark } from '@clerk/themes';

export function ClerkWaitlistWidget() {
  const { resolvedTheme } = useTheme();
  const { href: signInUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_INDEX as any,
  });

  return (
    <div className="h-full block overflow-x-hidden">
      <Waitlist
        afterJoinWaitlistUrl="https://www.agentselly.ch/?utm_source=clerk_waitlist&utm_medium=clerk_waitlist&utm_campaign=redirect&utm_content=%24%7B1%7D"
        signInUrl={signInUrl}
        appearance={{
          baseTheme: resolvedTheme === 'dark' ? dark : undefined,
          elements: {
            rootBox: 'w-full h-full',
            cardBox: 'rounded-none shadow-none w-full h-full',
          },
        }}
      />
    </div>
  );
}
